import React from "react"
import { Icon } from "@planningcenter/tapestry-react"
import { SidenavItem } from "@planningcenter/tapestry"

/**
 * @param {Object} props
 * @param {string} props.icon - name of icon to display on button, must also be imported into tapestry theme
 * @param {boolean} props.selected - when true, renders a variant that cannot be clicked
 * @param {number|function} props.count - the number of items matching this filter, or a function that returns the count (for lazy loading)
 * @param {string} props.title - the text label to display on the button
 * @param {function} props.onClick - function to be called when button is clicked
 * @param {function} props.generateAdditionalProps - function that given two arguments: selected, count - returns an object with two keys: button, badge - with additional props to apply to the button and badge subcomponents
 *
 * Any additional props supplied will be passed through to the Button component
 */
export default function SidebarFilterButton({
  icon,
  selected,
  count,
  title,
  onClick,
  generateAdditionalProps,
  ...props
}) {
  const additionalProps = generateAdditionalProps?.({
    selected,
    count: count?.() ?? count,
  })

  return (
    <SidenavItem selected={selected}>
      <button onClick={selected ? null : onClick} {...props}>
        {icon && (
          <span className="prefix">
            <Icon name={icon} />
          </span>
        )}
        <span className="label">{title}</span>
        {count && (
          <span
            className={`suffix badge badge--tiny badge--info ${!selected ? "badge--subtle" : "badge--bold"}
            ${additionalProps?.badgeClassName}`}
          >
            {typeof count === "function" ? count() : count}
          </span>
        )}
      </button>
    </SidenavItem>
  )
}
